// src/components/pages/reviewApiV2.js
import axios from 'axios';

const BASE = 'https://api.eilandigital.com/eilanApplication-0.0.1-SNAPSHOT';

const reviewApiV2 = {

  submitForReview: ({ taskId, version, ownerId, submittedBy, notes }) =>
    axios.post(`${BASE}/v2/review/submitForReview`, { taskId, version, ownerId, submittedBy, notes }),

  withdrawSubmission: ({ submissionId, ownerId, withdrawnBy }) =>
    axios.post(`${BASE}/v2/review/withdrawSubmission`, { submissionId, ownerId, withdrawnBy }),

  getOwnerSubmissionHistory: (taskId, version, ownerId) =>
    axios.get(`${BASE}/v2/review/getOwnerSubmissionHistory`, { params: { taskId, version, ownerId } }),

  getPendingReviews: (reviewerId) =>
    axios.get(`${BASE}/v2/review/getPendingReviews`, { params: { reviewerId } }),

  submitReviewWithRating: ({
    submissionId, reviewerId, action, comments,
    qualityRating, proofreadingRating,
    deadlineRating, briefRating, retakeRating,
    internalRating,
  }) =>
    axios.post(`${BASE}/v2/review/submitReviewWithRating`, {
      submissionId, reviewerId, action, comments,
      qualityRating, proofreadingRating,
      deadlineRating, briefRating, retakeRating,
      internalRating,
    }),

  getSubmissionReviewHistory: (submissionId) =>
    axios.get(`${BASE}/v2/review/getSubmissionReviewHistory`, { params: { submissionId } }),

  getFilteredReviews: (reviewerId, params = {}) =>
    axios.get(`${BASE}/v2/review/getFilteredReviews`, { params: { reviewerId, ...params } }),

  getFilteredStatistics: (reviewerId, params = {}) =>
    axios.get(`${BASE}/v2/review/getFilteredStatistics`, { params: { reviewerId, ...params } }),


  editReviewAction: (body) =>
    axios.post(`${BASE}/v2/review/editReviewAction`, body),

getReviewEditHistory: (reviewActionId) =>
    axios.get(`${BASE}/v2/review/getReviewEditHistory`, { params: { reviewActionId } }),
};

export default reviewApiV2;